import { useProduct } from 'src/hooks/api/useProduct';

export const useIsBuiltinBoard = () => {
  const { product } = useProduct();
  const sections = product?.boardSections.edges;
  return (id?: string) => !!id && sections?.some(s => s.node.boards.edges.some(b => b.node.isBuiltIn && b.node.id === id));
};
